__turbopack_context__.v({
  "burger-menu-button": "hlzCuW_burger-menu-button",
  "container": "hlzCuW_container",
  "image": "hlzCuW_image",
  "nav": "hlzCuW_nav",
  "nav-active": "hlzCuW_nav-active",
  "nav-close-button": "hlzCuW_nav-close-button",
  "nav-group-list-item": "hlzCuW_nav-group-list-item",
  "nav-group-list-item-active": "hlzCuW_nav-group-list-item-active",
  "nav-group-list-link": "hlzCuW_nav-group-list-link",
  "nav-groups-list": "hlzCuW_nav-groups-list",
  "nav-groups-list-columns-1": "hlzCuW_nav-groups-list-columns-1",
  "nav-groups-list-columns-2": "hlzCuW_nav-groups-list-columns-2",
  "nav-groups-list-item": "hlzCuW_nav-groups-list-item",
  "nav-groups-list-title": "hlzCuW_nav-groups-list-title",
  "nav-groups-list-title-additional-items": "hlzCuW_nav-groups-list-title-additional-items",
  "nav-hidden": "hlzCuW_nav-hidden",
  "nav-level-0": "hlzCuW_nav-level-0",
  "nav-level-0-active": "hlzCuW_nav-level-0-active",
  "nav-level-0-button": "hlzCuW_nav-level-0-button",
  "nav-level-0-list": "hlzCuW_nav-level-0-list",
  "nav-level-0-list-item": "hlzCuW_nav-level-0-list-item",
  "nav-level-0-list-item-active": "hlzCuW_nav-level-0-list-item-active",
  "nav-level-0-meta-button": "hlzCuW_nav-level-0-meta-button",
  "nav-level-1": "hlzCuW_nav-level-1",
  "nav-level-1-active": "hlzCuW_nav-level-1-active",
  "nav-level-1-back-button": "hlzCuW_nav-level-1-back-button",
  "nav-level-1-header": "hlzCuW_nav-level-1-header",
  "nav-level-1-title": "hlzCuW_nav-level-1-title",
  "placeholder": "hlzCuW_placeholder",
  "scroll-wrapper": "hlzCuW_scroll-wrapper",
  "teaser-list": "hlzCuW_teaser-list",
  "teaser-list-columns-1": "hlzCuW_teaser-list-columns-1",
  "teaser-list-columns-2": "hlzCuW_teaser-list-columns-2",
  "teaser-list-item": "hlzCuW_teaser-list-item",
  "teaser-list-item-image": "hlzCuW_teaser-list-item-image",
});
